import api from './api';
export async function searchRecords(query, category, signal) {
  const response = await api.get('/search', { params: { q: query, category }, signal });
  return response.data;
}
